import { Component, Inject, inject, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core'
import { NavigationStart, Router, RouterEvent, RouterLink, RouterOutlet } from '@angular/router'
import { BadgeModule } from 'primeng/badge'
import { StyleClassModule } from 'primeng/styleclass'
import { ButtonModule } from 'primeng/button'
import { Logo } from './core/components/logo/logo'
import { Footer } from './core/components/footer/footer'
import { NavItem } from './shared/intefaces/interfaces'
import { CallUsButton } from './shared/components/call-us-button/call-us-button'
import { filter, Subscription } from 'rxjs'
import { environment } from '../environments/environment'
import { ManageHeadElements } from './shared/services/manage-head-elements/manage-head-elements'
import { isPlatformBrowser } from '@angular/common'

@Component({
	selector: 'app-root',
	imports: [BadgeModule, StyleClassModule, RouterOutlet, ButtonModule, Logo, Footer, RouterLink, CallUsButton],
	templateUrl: './app.html',
	styleUrl: './app.css',
})
export class App implements OnInit, OnDestroy {
	navs = signal<NavItem[]>([])
	selectedNav = signal<string>('')

	navigation = [
		{
			label: 'Sell My Car',
			to: '/sell-my-car',
		},
		{
			label: 'About Us',
			to: '/about-us',
		},
		{
			label: 'How It Works',
			to: '/how-it-works',
		},
	]

	private router = inject(Router)
	private manageHeadElementService = inject(ManageHeadElements)

	subscription = new Subscription()

	constructor(
		@Inject(PLATFORM_ID) private platformId: Object,
	) {}

	ngOnInit(): void {
		this.navs.set(this.navigation)

		const sub1 = this.router.events
			.pipe(filter((e: any): e is RouterEvent => e instanceof NavigationStart))
			.subscribe((e: RouterEvent) => {
				const foundNav = this.navigation.find((nav) => nav.to === e.url)
				this.setSelectedNav(foundNav?.label || '')
			})

		this.manageHeadElementService.addLink('preconnect', environment.webStorageUrl)
		this.manageHeadElementService.addGTMScript()

		if (isPlatformBrowser(this.platformId)) {
			this.manageHeadElementService.addOneTrust()
		}

		this.subscription.add(sub1)
	}

	setSelectedNav = (navLabel: string): void => {
		this.selectedNav.set(navLabel)
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe()
	}
}
